module.exports = __webpack_public_path__ + "img/hongyouyanwobing.0500fd2a.jpg";